<template>
    <div class="multi-select-menu">
        <div class="checkbox-list">
            <label v-for="item in filteredItems" :key="item[itemValue]" class="checkbox-item">
                <input
                    type="checkbox"
                    :value="item[itemValue]"
                    v-model="localSelectedItems"
                    @change="updateSelection"
                />
                <span class="item-text" :style="{ color: item.active ? 'black' : 'rgba(141, 153, 146, 1)' }">
                    {{ t(item[itemText]) }}
                </span>
            </label>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        filteredItems: { type: Array, required: true },
        itemText: { type: String, required: true },
        itemValue: { type: String, required: true },
        selectedItems: { type: Array, default: () => [] },
    },
    data() {
        return {
            localSelectedItems: this.selectedItems,
        };
    },
    watch: {
        selectedItems(newVal) {
            this.localSelectedItems = newVal;
        },
    },
    methods: {
        updateSelection() {
            this.$emit("update", this.localSelectedItems);
        },
    },
};
</script>

<style scoped>
.multi-select-menu {
    display: flex;
    flex-direction: column;
}

.checkbox-list {
    max-height: 200px;
    overflow-y: auto;
}

.checkbox-item {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px;
    cursor: pointer;
    font-size: 14px;
    border-radius: 4px;
    white-space: nowrap;
}

.checkbox-item:hover {
    background-color: #f5f5f5;
}

.item-text {
    flex: 1;
    font-weight: 500;
}

.checkbox-item input[type="checkbox"] {
    cursor: pointer;
}

.checkbox-item input[type="checkbox"]:checked {
    accent-color: #ff0000;
}
</style>
